import { addLocale, locale } from 'primereact/api';

import { primeReactLocaleDE } from '@shared/providers/PrimeReactConfiguration/locale/de.ts';
import { primeReactLocaleES } from '@shared/providers/PrimeReactConfiguration/locale/es.ts';
import { primeReactLocaleIT } from '@shared/providers/PrimeReactConfiguration/locale/it';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import '@appTheme/theme-css-variables.scss';
import '@appTheme/components/progressspinner/spinner-pending.scss';

// mandatory locale for PrimeReact for Italy | Spanish language" (got from official github PrimeReact i.e: https://github.com/primefaces/primelocale/blob/main/it.json)
addLocale('it', primeReactLocaleIT);
addLocale('es', primeReactLocaleES);
addLocale('de', primeReactLocaleDE);

// set default language for PrimeReact
locale('en');

export const primeReactConfiguration = {
  ripple: true,
};
